export default __webpack_public_path__ + "static/media/container.ae710457.jpg";